import React from "react";
 import { FaWhatsapp } from "react-icons/fa";


const WhatsAppFloating = () => {
  const phoneNumber = "919141183333"; // ✅ Replace with your full WhatsApp number

  const openWhatsApp = () => {
    window.open(`https://wa.me/${phoneNumber}`, "_blank");
  };

  return (
    <div
      onClick={openWhatsApp}
      style={{
        position: "fixed",
        right: "0.1%",
        top: "80%",
        transform: "translateY(-50%)",
        zIndex: 1000,
        cursor: "pointer",
        backgroundColor: "#25D366",
        padding: "12px",
        borderRadius: "50%",
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
       }}
      title="Direct Query Chat on WhatsApp"
    >
       <FaWhatsapp size={23} color="#fff"  />
    </div>
  );
};

export default WhatsAppFloating;
